import React, { useState } from "react";
import classes from './Search.module.css'

const Search = ({ onSearch }) => {
    const [search, setSearch] = useState("");

    const onInputChange = value => {
        setSearch(value);
        onSearch(value);
    };
    return (
        <label className={classes.label}>
        <input
            type="text"
            className={`form-control ${classes.input}`}
            style={{ maxWidth: "220px" }}
            placeholder="Search using keywords..."
            value={search}
            onChange={e => onInputChange(e.target.value)}
        />
        </label>
    );
};

export default Search;